/* import __COLOCATED_TEMPLATE__ from './translate-conversation-skip-languages-tooltip.hbs'; */
/* RESPONSIBLE TEAM: team-inbox-management */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type IntlService from 'embercom/services/intl';
import type Session from 'embercom/services/session';

interface Args {
  dynamicArgs: {
    conversationLanguage?: string;
  };
}

interface Signature {
  Args: Args;
}

export default class TranslateConversationSkipLanguagesTooltip extends Component<Signature> {
  @service declare intl: IntlService & { languageNameFromCode: (code: string) => string };
  @service declare session: Session;

  get languageName(): string {
    let languageCode = this.args.dynamicArgs.conversationLanguage;
    if (!languageCode) {
      return '';
    }

    return this.intl.languageNameFromCode(languageCode) || languageCode;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::TranslateConversationSkipLanguagesTooltip': typeof TranslateConversationSkipLanguagesTooltip;
    'inbox2/translate-conversation-skip-languages-tooltip': typeof TranslateConversationSkipLanguagesTooltip;
  }
}
